import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import Cards from './components/Cards';
import Comments from './components/Comments';
import Faq from './components/Faq';
import Features from './components/Features';
import Updates from './components/Updates';
import AppDownload from './components/AppDownload';
import About from './components/About';
import Index from './components/Index';
import Carousel from './components/Carousel';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Media from './components/Media';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Topics />
        <Cards />
        <Comments />
        <Faq />
        <Features />
        <Updates />
        <AppDownload />
        <About />
        <Index />
        <Carousel />
        <Ranking />
        <Contact />
        <Media />
      </main>
      <Footer />
    </>
  );
}